export default (urlParameters) => {
  return {
    wind_graph: {
      show_data_fields_menu: false,
      show_nearby_spots: false,
      show_virtual: false,
      default_graph: 'basic',
    },
    pro_forecast: {
      id: null,
    },
    station_info: {
      show_full_metadata: false,
    },
    archive_data: {
      allow_data_download: false,
    },
  }
}